<template>
<div v-if="isMain">
    <header>各種設定<div class="h-left"><a @click="$router.push({name: 'profile'}); setFooter(true)"><img src="~@/assets/images/icon02.svg"></a></div>
    </header>
    <div id="wrap">
        <div class="search-form-title">アカウント設定</div>
        <div class="txt-area">
            <div class="btn7"><a @click="isMain = false; isNotice = true; setScrollPosition(); showChild()">通知設定</a></div>
            <div class="btn7"><a @click="isMain = false; isBlock = true; setScrollPosition(); showChild()">ブロックリスト</a></div>
            <div class="btn7"><a @click="isMain = false; isMessageHidden = true; setScrollPosition(); showChild()">メッセージ非表示リスト</a></div>
            <div class="btn4"><a @click="isMain = false; isMessageTemplate = true; setScrollPosition(); showChild()">メッセージテンプレート設定</a></div>
        </div>

        <div class="search-form-title">お支払い状況</div>
        <div class="txt-area">
            <div class="btn4"><a @click="isMain = false; isBilling = true; setScrollPosition(); showChild()">定額課金設定</a></div>
        </div>

        <div class="search-form-title">プライバシー設定</div>
        <div class="txt-area">
            <div class="btn7"><a @click="isMain = false; isFootprint = true; setScrollPosition(); showChild()">足あと設定</a></div>
            <div class="btn4"><a @click="isMain = false; isPrivateModeSetting = true; setScrollPosition(); showChild()">プライべートモード設定</a></div>
        </div>

        <div class="search-form-title">サポート</div>
        <div class="txt-area">
            <div class="btn7"><a @click="isMain = false; isPointTable = true; setScrollPosition(); showChild()">ポイント表</a></div>
            <div class="btn7"><a @click="isMain = false; isPointHistory = true; setScrollPosition(); showChild()">ポイントの履歴</a></div>
            <div class="btn7"><a @click="isMain = false; isOtherPages = true; siteName = 'guide'; setScrollPosition(); showChild()">安心してご利用いただくために</a></div>
            <div class="btn4"><a @click="isMain = false; isOtherPages = true; siteName = 'help_page'; setScrollPosition(); showChild()">よくあるお問い合わせ</a></div>
        </div>

        <div class="search-form-title">その他</div>
        <div class="txt-area">
            <div class="btn7"><a @click="isMain = false; isOtherPages = true; siteName = 'operating_company'; setScrollPosition(); showChild()">運営会社</a></div>
            <div class="btn7"><a @click="isMain = false; isOtherPages = true; siteName = 'terms_of_use'; setScrollPosition(); showChild()">利用規約</a></div>
            <div class="btn7"><a @click="isMain = false; isOtherPages = true; siteName = 'privacy_policy'; setScrollPosition(); showChild()">プライバシーポリシー</a></div>
            <div class="btn7"><a @click="isMain = false; isOtherPages = true; siteName = 'commercial_law_show'; setScrollPosition(); showChild()">特定商取引法に基づく表示</a></div>
            <div class="btn7"><a @click="isMain = false; isOtherPages = true; siteName = 'fund_law_show'; setScrollPosition(); showChild()">資金決済法に基づく表示</a></div>
            <div class="btn4"><a @click="logout()">ログアウト</a></div>
        </div>
    </div>
</div>

<div id="child" class="hidden" style="overflow: auto;">
    <!-- Notification setting -->
    <notice v-if="isNotice" :isShow="isNotice" @close="isNotice = false; scrollToPosition(); hiddenChild()"/>
    <block v-if="isBlock" :isShow="isBlock" @close="isBlock = false; scrollToPosition(); hiddenChild()"></block>
    <billing :isShow="isBilling" @close="isBilling = false; scrollToPosition(); hiddenChild()"></billing>
    <footprint v-if="isFootprint" :isShow="isFootprint" @close="isFootprint = false; scrollToPosition(); hiddenChild()"></footprint>
    <forSafeUse :isShow="isForSafeUse" @close="isForSafeUse = false; scrollToPosition(); hiddenChild()"></forSafeUse>
    <frequentlyAskedQuestions :isShow="isFrequentlyAskedQuestions" @close="isFrequentlyAskedQuestions = false; scrollToPosition(); hiddenChild()"></frequentlyAskedQuestions>
    <messageHidden v-if="isMessageHidden" :isShow="isMessageHidden" @close="isMessageHidden = false; scrollToPosition(); hiddenChild()"></messageHidden>
    <messageTemplate v-if="isMessageTemplate" :isShow="isMessageTemplate" @close="isMessageTemplate = false; scrollToPosition(); hiddenChild()"></messageTemplate>
    <otherPages :isShow="isOtherPages" @close="isOtherPages = false; scrollToPosition(); hiddenChild()" :siteName="siteName"></otherPages>
    <pointHistory :isShow="isPointHistory" @close="isPointHistory = false; scrollToPosition(); hiddenChild()"></pointHistory>
    <pointTable v-if="isPointTable" :isShow="isPointTable" @close="isPointTable = false; scrollToPosition(); hiddenChild()"></pointTable>
    <privateModeSetting v-if="isPrivateModeSetting" :isShow="isPrivateModeSetting" @close="isPrivateModeSetting = false; scrollToPosition(); hiddenChild()"></privateModeSetting>
</div>
</template>

<script>
import CONSTANTS from "@/constants"
import {
  mapActions,
  mapGetters
} from "vuex"
import notice from "./components/setting/notice"
import billing from "./components/setting/billing"
import block from "./components/setting/block"
import footprint from "./components/setting/footprint"
import forSafeUse from "./components/setting/forSafeUse"
import frequentlyAskedQuestions from "./components/setting/frequentlyAskedQuestions"
import messageHidden from "./components/setting/messageHidden"
import messageTemplate from "./components/setting/messageTemplate"
import otherPages from "./components/setting/otherPages"
import pointHistory from "./components/setting/pointHistory"
import pointTable from "./components/setting/pointTable"
import privateModeSetting from "./components/setting/privateModeSetting"
export default {
    components: {
        notice, billing, block, footprint, forSafeUse, frequentlyAskedQuestions, messageHidden,
        messageTemplate, otherPages, pointHistory, pointTable, privateModeSetting
    },
    data: () => ({
        isMain: true,
        isNotice: false,
        isBlock: false,
        isMessageHidden: false,
        isMessageTemplate: false,
        isBilling: false,
        isFootprint: false,
        isPrivateModeSetting: false,
        isPointTable: false,
        isPointHistory: false,
        isForSafeUse: false,
        isFrequentlyAskedQuestions: false,
        isOtherPages: false,
        siteName: null,
        scrollPosition: 0
    }),

    computed: {
        ...mapGetters(["metadata", 'defaultToken']),

        isAnyDialogOpen() {
            return this.isNotice ||
                this.isBlock ||
                this.isMessageHidden ||
                this.isMessageTemplate ||
                this.isBilling ||
                this.isFootprint ||
                this.isPrivateModeSetting ||
                this.isPointTable ||
                this.isPointHistory ||
                this.isForSafeUse ||
                this.isFrequentlyAskedQuestions ||
                this.isOtherPages;
            
        }
    },
    mounted() {
        this.setFooter(false)
    },
    watch: {
        isAnyDialogOpen(val) {
            const body = document.getElementsByTagName('body')[0];
            if (val) {
                window.scrollTo(0, 0);
                setTimeout(() => {
                    body.style.overflow = "hidden";
                }, 10);
            }
            else body.style.overflow = "auto";
        }
    },
    methods: {
        ...mapActions({
            setFooter: "layout/setFooter"
        }),
        setScrollPosition() {
            this.scrollPosition = window.scrollY;
        },
        scrollToPosition() {
            setTimeout(() => {
                window.scrollTo(0, this.scrollPosition)
            }, 10);
        },
        logout() {
            this.$store.dispatch('login/logout');
        },
        showChild() {
            document.getElementById('child').classList.add('show')
            document.getElementById('child').classList.remove('hidden')
            
        },
        hiddenChild() {
            document.getElementById('child').classList.remove('show')
            document.getElementById('child').classList.add('hidden')
            this.isMain = true; 
        }
    },
};
</script>

<style scoped>
#child {
    transition: right 0.2s;
}
.hidden {
    position: fixed;
    right: -100%;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.show {
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    overflow: hidden;
    height: 100%;
}
</style>